import { Box, Card, CardContent, Typography } from '@mui/material';
import axios from 'axios';
import QrCreator from 'qr-creator';
import React, { Component } from 'react';
import BuamaList from './BuamaList';
import { buamatogColors } from './theme';
import { User } from './Types/Types';
interface Props {
    user: User|null
};
class Buddies extends Component<Props, {users: User[],isQrCodeLoaded:boolean}> {
    fetchBuddiesInterval : number | undefined = undefined;

    constructor(props : Props) {
        super(props);
        const userStr = localStorage.getItem('buddies');
        this.state={
            users: JSON.parse(userStr ?? '[]'),
            isQrCodeLoaded: false,
        };
    }
    

    componentDidMount() {
        this.load()
        window.clearInterval(this.fetchBuddiesInterval);
        this.fetchBuddiesInterval = window.setInterval(() => {
            this.load();
        }, 1000 * 15);
        this.handleLoadQrCode();
    }

    componentWillUnmount() {
        window.clearInterval(this.fetchBuddiesInterval);
    }
    

    handleLoadQrCode = () => {
        const { user } = this.props;
        const { isQrCodeLoaded } = this.state;
        if (user && !isQrCodeLoaded) {
            let elem = document.getElementById('profile-qr-code');
            if (elem) {
                elem.replaceChildren();
                QrCreator.render({
                    text: process.env.REACT_APP_HOST + '/buddies/'+user.id,
                    radius: 0.5, // 0.0 to 0.5
                    ecLevel: 'L', // L, M, Q, H
                    fill: buamatogColors.golden, // foreground color - golden
                    background: buamatogColors.darkerGrey, // color or null for transparent
                    size: 200 // in pixels
                }, elem);
            }
        }
    }
    
    load = () => {
        axios.get<User[]>('/buddies')
            .then(res => {
                const users = res.data;

                localStorage.setItem('buddies', JSON.stringify(users));
                this.setState({
                    users: users,
                });
            });
    }

    render() {
        const { users } = this.state;
        
        return (
            <React.Fragment>
                <Box flexGrow={0} sx={{ minHeight: '240px', marginTop: '10px', marginBottom: '10px', display: 'grid', placeItems: 'center' }}>
                    <Card sx={{ display: 'grid', placeItems: 'center', width: '240px', height: '240px', overflow: 'hidden', backgroundColor: buamatogColors.mediumGrey, border: '1px solid rgba(255, 215, 0, 0.18)' }}>
                        <CardContent sx={{ display: 'grid', placeItems: 'center', p: 0, pb: '0px !important' }}>
                            <div id="profile-qr-code" style={{ height: '200px' }}></div>
                        </CardContent>
                    </Card>
                </Box>
                <Box textAlign={'center'}>
                    <Typography textAlign={'center'} variant={'h4'} sx={{ p: 2, paddingBottom: 0 }}>Eppan G'sechn</Typography>
                    <Typography textAlign={'center'} variant={'body2'} sx={{ p: 2, paddingTop: 0 }}>Oana vo ench zwoa duat mit den QR-Code-Drum an ondan scannen</Typography>
                </Box>
                <Box flexGrow={1} flexBasis={'400px'}>
                    <BuamaList showTimestamp={true} users={users}/>
                </Box>
            </React.Fragment>
        );
    }
}
export default Buddies;